import { useEffect } from 'react';
import { toggleLoadingCursor } from '@/shared/lib/browser';
import type { ButtonLoadingProps } from './buttonLoading';

const useButtonLoading = ({
  shouldDisplayLoadingCursor = false,
}: Pick<ButtonLoadingProps, 'shouldDisplayLoadingCursor'>) => {
  useEffect(() => {
    if (shouldDisplayLoadingCursor) {
      toggleLoadingCursor(true);
      return () => {
        toggleLoadingCursor(false);
      };
    }
    return undefined;
  }, []);
};

export default useButtonLoading;
